import { EmailTemplateResponse } from '@/types/service-response'

export class EmailTemplate {
  private constructor (
    readonly id: number | null,
    readonly eMailTemplateGruppe: number | null,
    readonly eMailTemplateType: number | null,
    readonly sprache: number | null,
    readonly bezeichnung: string | null,
    readonly HTML: number | null,
    readonly subject: string | null,
    readonly body: string | null

  ) {}

  public static createListFromResponse (data: EmailTemplateResponse[]): Array<EmailTemplate> {
    return data.map((item: EmailTemplateResponse) => {
      return new EmailTemplate(
        item.ID,
        item.EMailTemplateGruppe,
        item.EMailTemplateType,
        item.Sprache,
        item.Bezeichnung,
        item.HTML,
        item.Subject,
        item.Body
      )
    })
  }
}
